// @ts-check

import React from 'react';
import { array, func, object } from 'prop-types';
import USER from '../ts/profileEditorEnum';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

/**
 * @component AccessibleSelector
 * @param {Object} props
 * @param {CompanyType} props.value
 * @param {CompanyType[]} props.options
 * @param {EditorValidType} props.valid
 * @param {(name:string, payload:any) => void} props.onHandle
 * @returns {JSX.Element}
 */
function AccessibleSelector({ value, options, valid, onHandle }) {
	return (
		<>
			{value !== undefined && (
				<Autocomplete
					fullWidth
					value={value}
					options={options}
					// @ts-ignore
					getOptionLabel={(option) => (option.Name ? option.Name : '')}
					onChange={(e, newValue) => onHandle(USER.ACCESSIBLE, newValue)}
					renderInput={(params) => {
						return (
							<TextField
								{...params}
								variant="outlined"
								label="Accessible Data"
								required
								InputLabelProps={{ shrink: true }}
								error={valid.hasErr}
								helperText={valid.msg}
							/>
						);
					}}
					sx={{ '& .MuiAutocomplete-input': { height: '1.15rem' } }}
				/>
			)}
		</>
	);
}

AccessibleSelector.propTypes = {
	value: object,
	options: array,
	valid: object,
	onHandle: func,
};

export default AccessibleSelector;
